export enum TabLayout {
  HORIZONTAL = 'horizontal',
  STACKED = 'stacked',
}

export enum SelectorType {
  CIRCLE = 'circle',
  UNDERLINE = 'underline',
}

export enum TabDesign {
  DEFAULT = 'white',
  TRANSPARENT = 'transparent',
  SOLID = 'solid',
  THEMED = 'light',
  PILL = 'pill',
  ICON_CIRCLE = 'icon-circle',
}
export enum TabType {
  DEFAULT = 'default',
  COMPACT = 'compact-tabs-container',
  COMPACT_WITH_PADDING = 'compact-tabs-container-with-padding',
}
